import type { AppContext } from 'types/common'

import component from './Interchange.svelte'
import { graphql, type InterchangeScreenData$result } from '$houdini'

export type InventoryType = InterchangeScreenData$result['inventoryTypes'][number]

const interchangeData = graphql(`
	query InterchangeScreenData($inventoryTypeFilter: InventoryTypeFilter) {
		inventoryTypes(filter: $inventoryTypeFilter) {
			id
			name
		}
	}
`)

export default function ({ stateRouter }: AppContext) {
	stateRouter.addState({
		name: 'app.interchange',
		route: 'interchange',
		querystringParameters: ['refresh', 'lastSearchType'],
		template: {
			svelte: true,
			component,
		},
		async resolve(
			_data,
			{ inventoryTypeId, year, manufacturer, model, interchangeNumber, subInterchangeNumber, lastSearchType },
		) {
			const { data } = await interchangeData.fetch({
				variables: {
					inventoryTypeFilter: {
						active: true,
					},
				},
			})

			let inventoryType: InventoryType | null = null
			if (inventoryTypeId) {
				const parsedInventoryTypeId = inventoryTypeId ? parseInt(inventoryTypeId, 10) : null
				inventoryType = parsedInventoryTypeId
					? (data?.inventoryTypes.find(it => it.id === parsedInventoryTypeId) ?? null)
					: null
			}

			return {
				inventoryTypeList: data?.inventoryTypes ?? [],
				inventoryType,
				year: year ? parseInt(year, 10) : null,
				initialManufacturer: manufacturer ?? undefined,
				initialModel: model ?? undefined,
				interchangeNumber: interchangeNumber ?? '',
				subInterchangeNumber: subInterchangeNumber ?? '',
				lastSearchType: lastSearchType ?? 'VEHICLE_INFO',
			}
		},
	})
}
